var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTabDescriptionIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.759,
    height: 17.783,
    viewBox: "0 0 30.759 17.783",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12526",
    "data-name": "Group 12526",
    transform: "translate(1196.916 -396.464)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12520",
    "data-name": "Group 12520",
    transform: "translate(-2478 -417)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39704",
    "data-name": "Path 39704",
    d: "M1292.267,823.971h0a5.967,5.967,0,1,1,8.439,0A5.984,5.984,0,0,1,1292.267,823.971Z",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 0.655
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_599",
    "data-name": "Line 599",
    x2: 7.316,
    y2: 6.62,
    transform: "translate(1300.422 824.384)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 0.655
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39705",
    "data-name": "Path 39705",
    d: "M1300.328,815.186h11.187v9.234h-11.093",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 0.655
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39706",
    "data-name": "Path 39706",
    d: "M1292.635,815.186h-11.224v9.234h11.067",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 0.655
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_600",
    "data-name": "Line 600",
    y2: 6.003,
    transform: "translate(1284.399 816.793)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 0.655
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_601",
    "data-name": "Line 601",
    y2: 6.003,
    transform: "translate(1289.225 816.793)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 0.655
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_602",
    "data-name": "Line 602",
    y2: 6.003,
    transform: "translate(1303.702 816.793)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 0.655
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_603",
    "data-name": "Line 603",
    y2: 6.003,
    transform: "translate(1308.527 816.793)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 0.655
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabDescriptionIcon);
export default __webpack_public_path__ + "static/media/tab-description-icon.9be5154c353d1396ec698c85fa27ece3.svg";
export { ForwardRef as ReactComponent };